export default {
  state: {
    userLogin: {
      cpf: "",
      password: "",
    },

    userNoAuth: {},
    unityAndProfile: {},
  },

  getters: {
    getUserLogin(state) {
      return state.userLogin;
    },

    getUserNoAuth(state) {
      return state.userNoAuth;
    },

    getUnityAndProfile(state) {
      return state.unityAndProfile;
    },
  },

  mutations: {
    setUserLogin(state, user) {
      state.userLogin = user;
    },

    setUserNoAuth(state, user) {
      state.userNoAuth = user;
    },

    setUnityAndProfile(state, data) {
      state.unityAndProfile = data;
    },
  },

  actions: {
    changeUserLogin(context, user) {
      context.commit("setUserLogin", user);
    },

    changeUserNoAuth(context, user) {
      context.commit("setUserNoAuth", user);
    },

    changeUnityAndProfile(context, data) {
      context.commit("setUnityAndProfile", data);
    },
  },
};
